import { inject } from '@angular/core';
import { Department } from '@map/models';
import { DepartmentService } from '@map/services/department.service';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { upsertEntities, withEntities } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { updateState, withDevtools, withDevToolsStub } from '@angular-architects/ngrx-toolkit';
import { environment } from 'src/environments/environment';

type DepartmentState = {
    loading: boolean;
    loaded: boolean;
};

const initialState: DepartmentState = {
    loading: false,
    loaded: false,
};

export const withTreeShakableDevTools = environment.production ? withDevToolsStub : withDevtools;

export const DepartmentStore = signalStore(
    { providedIn: 'root' },
    withTreeShakableDevTools('departments'),
    withEntities<Department>(),
    withState<DepartmentState>(initialState),
    withMethods((store, departmentService = inject(DepartmentService)) => ({
        getAll: rxMethod<void>(
            pipe(
                switchMap(() => {
                    if (store.entities().length > 0) return store.entities();
                    updateState(store, '[Department] Get All', { loading: true });
                    return departmentService.getAll<Department[]>().pipe(
                        tapResponse({
                            next: (departments) => {
                                updateState(store, '[Department] Get All Success', upsertEntities(departments), {
                                    loaded: true,
                                    loading: false,
                                });
                            },
                            error: (error) => {
                                console.error('Error fetching departments:', error);
                                updateState(store, '[Department] Get All Failure', { loading: false });
                            },
                        })
                    );
                })
            )
        ),
    }))
);
